var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 18,
    height: 18,
    transform: "translate(1075 27)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    transform: "translate(-1075 -27)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1074.061 26.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18,15.411a7.974,7.974,0,0,1-1.39-1.623,6.994,6.994,0,0,1-.748-2.664V8.389a5.986,5.986,0,0,0-5.227-5.953V1.722a.739.739,0,1,0-1.479,0v.725A5.986,5.986,0,0,0,3.993,8.389v2.736a6.994,6.994,0,0,1-.748,2.664,7.974,7.974,0,0,1-1.368,1.623.554.554,0,0,0-.188.415v.753a.554.554,0,0,0,.554.554H17.637a.554.554,0,0,0,.554-.554v-.753A.554.554,0,0,0,18,15.411Zm-15.162.615a8.954,8.954,0,0,0,1.351-1.661,7.885,7.885,0,0,0,.914-3.239V8.389a4.84,4.84,0,1,1,9.674,0v2.736a7.885,7.885,0,0,0,.914,3.239,8.954,8.954,0,0,0,1.351,1.661Z",
    fill: "#7a808b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M9.968,18.983A1.479,1.479,0,0,0,11.4,17.72H8.484a1.479,1.479,0,0,0,1.484,1.263Z",
    fill: "#7a808b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ea81d9e0aaa38ca8e4db9f809187e411.svg";
export { ForwardRef as ReactComponent };